import { Box, Chip, Tooltip, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { Store } from "@material-ui/icons"
import useAppStore from "../../stores/AppStore"

const useStyles = makeStyles(theme => ({
    chip: {
        backgroundColor: "rgba(255,255,255,0.15)",
        color: "#fff",
        marginRight: theme.spacing(1),
        maxWidth: 260,
        cursor: "pointer",
        "&:hover": { backgroundColor: "rgba(255,255,255,0.28)" },
        "& .MuiChip-label": {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        "& .MuiChip-icon": { color: "#fff" },
    },
    chipSelecionar: {
        backgroundColor: "#ffb300",
        color: "#1a1a1a",
        "& .MuiChip-icon": { color: "#1a1a1a" },
        "&:hover": { backgroundColor: "#ffa000" },
    },
    nomeRede: {
        fontSize: 11,
        opacity: 0.85,
        marginTop: -2,
    },
    codigo: {
        fontSize: 10,
        fontWeight: 700,
        backgroundColor: "rgba(255,255,255,0.25)",
        borderRadius: 4,
        padding: "1px 5px",
        lineHeight: 1.4,
    },
}))

export default function IndicadorEstabelecimento({ onClick }) {
    const classes = useStyles()
    const estabelecimento = useAppStore(s => s.configuracoes?.user?.parametros?.estabelecimento)
    const possuiAtual = !!estabelecimento?.id

    if (!possuiAtual) {
        return (
            <Chip
                icon={<Store />}
                label="Selecionar estabelecimento"
                onClick={onClick}
                className={`${classes.chip} ${classes.chipSelecionar}`}
            />
        )
    }

    const nome = estabelecimento.nomeAlternativo || estabelecimento.nome || "Estabelecimento"
    const nomeRede = estabelecimento.nomeRede
    const id = estabelecimento.id

    const conteudo = (
        <Box display="flex" flexDirection="column" alignItems="flex-start" style={{ lineHeight: 1 }}>
            <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                {id != null && <span className={classes.codigo}>{id}</span>}
                <Typography variant="body2" component="span" style={{ fontWeight: 500 }}>
                    {nome}
                </Typography>
            </Box>
            {nomeRede && (
                <Typography component="span" className={classes.nomeRede}>
                    {nomeRede}
                </Typography>
            )}
        </Box>
    )

    const tituloTooltip = [id != null ? `ID ${id}` : null, nome, nomeRede]
        .filter(Boolean)
        .join(" · ")

    return (
        <Tooltip arrow title={tituloTooltip || "Clique para trocar de estabelecimento"}>
            <Chip
                icon={<Store />}
                label={conteudo}
                onClick={onClick}
                className={classes.chip}
            />
        </Tooltip>
    )
}
